module.exports = __webpack_public_path__ + "img/banner.8197ef0f.jpg";